import Cookies from "js-cookie";
import { cookieOptions, otherApiClient } from ".";
export const getMe = async (accessToken)=>{
    var _data_option, _data_option1, _data_option2, _data_option3;
    Cookies.set("accessToken", accessToken, {
        ...cookieOptions
    });
    const headers = {
        Authorization: accessToken
    };
    const { data  } = await otherApiClient.market.get("/users/meta", {
        headers
    });
    return {
        user: {
            displayName: data.nickname,
            email: data.email,
            maskedEmail: data.maskedEmail,
            phoneNumber: data.phone,
            maskedPhone: data.maskedPhone,
            photoURL: null,
            providerId: data.provider.channel,
            uid: data.uid,
            mainSubject: data.mainSubject,
            job: data.job,
            schoolItems: data.schoolItems,
            id: data.userId,
            emailVerified: data.emailVerified,
            address: data.address,
            flags: {
                // 레거시 플래그 값. 명시적으로 true인 경우에만 true, 그 외는 false. 최소 적용
                is_use_lab: (data === null || data === void 0 ? void 0 : (_data_option = data.option) === null || _data_option === void 0 ? void 0 : _data_option.use_lab) === true || (data === null || data === void 0 ? void 0 : (_data_option1 = data.option) === null || _data_option1 === void 0 ? void 0 : _data_option1.use_lab) === "true" ? true : false,
                // drm이 명시적으로 false인 경우에만 false, 그 외는 true. drm은 최대 적용.
                drm: (data === null || data === void 0 ? void 0 : (_data_option2 = data.option) === null || _data_option2 === void 0 ? void 0 : _data_option2.drm) === false || (data === null || data === void 0 ? void 0 : (_data_option3 = data.option) === null || _data_option3 === void 0 ? void 0 : _data_option3.drm) === "false" ? false : true
            },
            brand: data.brand,
            hasUsableFreepass: data.hasUsableFreepass,
            isAuthor: data.isAuthor,
            birth: data.birth,
            // ms-v2.5.0 신규 필드
            schoolGrade: data.schoolGrade,
            education: data.education,
            promotionAgreed: data.promotionAgreed,
            hasSignupBenefitLog: data.hasSignupBenefitLog,
            createdAt: data.createdAt
        }
    };
};
